import { Text } from '@dixa/lib-shared-habla';

export function RoutedThroughReply(): JSX.Element {
  return (
    <Text.Paragraph>Reply · Automation visited reply action</Text.Paragraph>
  );
}
